import { render, staticRenderFns } from "./ManageInternalDashboard.vue?vue&type=template&id=0194c8f0"
import script from "./ManageInternalDashboard.vue?vue&type=script&lang=js"
export * from "./ManageInternalDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports